import { render, staticRenderFns } from "./ConversationInsight.vue?vue&type=template&id=b22a7998&scoped=true"
import script from "./ConversationInsight.vue?vue&type=script&lang=js"
export * from "./ConversationInsight.vue?vue&type=script&lang=js"
import style0 from "./ConversationInsight.vue?vue&type=style&index=0&id=b22a7998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a7998",
  null
  
)

export default component.exports